import { createFileRoute } from "@tanstack/react-router";
import { DefiTokensPage } from "../../features/defi/pages/defi-tokens-page";
import type { ProtocolKey } from "../../shared/utils/protocol-data";

export const Route = createFileRoute("/_layout/defi/stablecoins/")({
  component: DefiTokensPage,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      protocolKey: search.protocolKey as ProtocolKey | undefined,
    };
  },
});
